import { useEffect, useState } from "react";
import { Sparkles, MapPin } from "lucide-react";
import { getSpotlightCurrent } from "@/lib/api";

/**
 * Banner that surfaces the currently-active Spotlight sponsor for a slot.
 * Slot is either 'homepage' or 'state:<state-slug>'.
 * Renders nothing if there's no active sponsor — never a layout-shift placeholder.
 */
export default function SpotlightBanner({ slot, label = "FEATURED FIRM" }) {
    const [data, setData] = useState(null);

    useEffect(() => {
        if (!slot) return;
        getSpotlightCurrent(slot)
            .then(setData)
            .catch(() => setData(null));
    }, [slot]);

    if (!data?.sponsor) return null;
    const s = data.sponsor;

    return (
        <div
            className="border-2 border-[#FFCC00] bg-[#FFCC00]/5 p-5 sm:p-6"
            data-testid="spotlight-banner"
        >
            <div className="flex items-center gap-2 mb-2">
                <Sparkles size={14} className="text-[#FFCC00]" />
                <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#FFCC00]">
                    {label} · SPONSORED
                </span>
            </div>
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                <div>
                    <h3 className="font-anton text-3xl sm:text-4xl uppercase leading-tight">
                        {s.firm_name}
                    </h3>
                    <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/70 mt-2 flex items-center gap-3 flex-wrap">
                        {s.states?.length > 0 && (
                            <span className="flex items-center gap-1">
                                <MapPin size={10} /> {s.states.slice(0, 3).join(" · ")}
                            </span>
                        )}
                        {s.languages?.length > 0 && (
                            <span>{s.languages.slice(0, 3).join(" · ")}</span>
                        )}
                        <span className="text-[#FFCC00]">TIER {(s.tier || "starter").toUpperCase()}</span>
                    </div>
                    {s.specialities?.length > 0 && (
                        <div className="mt-3 flex flex-wrap gap-2">
                            {s.specialities.slice(0, 5).map((sp) => (
                                <span
                                    key={sp}
                                    className="font-mono text-[10px] uppercase tracking-wider px-2 py-1 border border-white/20 text-white/70"
                                >
                                    {sp.replace(/_/g, " ")}
                                </span>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
